import React from 'react';

import "./index.scss";

/**
 * @param children - all children of this component
 * @param style send styles to use in div container
 * @param customClasses - send classnames to use in div container
 * @param dataCy - cy param to use for tests with cypress 
 * @example <Box dataCy='any-unique-value' customClasses='any-classname' style={...anyStyle}>{...children}</Box>
 * @returns JSX Element
 */
function Box(props: any) {

    const { children, style, customClasses, dataCy } = props; // propriedades que recebe

    const background = props.hasOwnProperty("background") && props.background;
    const borderRadius = props.hasOwnProperty("borderRadius") && props.borderRadius;

    const styleLocal: React.CSSProperties = {
        backgroundColor: background,
        borderRadius: borderRadius,
    }

    return (
        <div>
            <div
                data-cy={dataCy || ''}
                className={`box-container ${customClasses ? customClasses : ``}`}
                style={(style && Object.keys(style).length > 0) ? style : styleLocal}
            >
                {children}
            </div>
        </div>
    );
}

export default Box;
